module.exports = "/images/da.svg";